<script lang="ts">
    import {getCdnUrl} from "$lib/cdn";
    import ButtonGroup from "../Elements/ButtonGroup.svelte";

    export let section: Section;
    export let index: number;

    $: imageUrls = section.images.data.map((image) => {
        if (image.attributes.formats?.medium) {
            return image.attributes.formats.medium.url
        }
        return image.attributes.url
    });

</script>

<div class="relative isolate">
    <div class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">
        <div class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"></div>
    </div>
    <div class="overflow-hidden">
        <div class="mx-auto max-w-7xl px-6 pb-32 pt-12 sm:pt-12 lg:px-8 lg:pt-12">
            <div class="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                <div class="w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
                    {#if index === 0}
                        <h1 class="text-5xl tracking-tight text-gray-900 sm:text-6xl font-display">{section.title}</h1>
                    {:else}
                        <h2 class="text-4xl tracking-tight text-gray-900 sm:text-5xl font-display">{section.title}</h2>
                    {/if}

                    <p class="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">{section.description}</p>
                    {#if section.cta.length > 0}
                        <div class="mt-10 flex items-center gap-x-6">
                            <ButtonGroup buttons={section.cta} />
                        </div>
                    {/if}
                </div>
                <div class="mt-14 flex justify-end gap-8 sm:-mt-44 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0">

                    {#if imageUrls[0]}
                        <div class="ml-auto w-44 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
                            <div class="relative">
                                <img src={getCdnUrl(imageUrls[0])}
                                     alt="" class="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg">
                                <div class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"></div>
                            </div>
                        </div>
                    {/if}
                    <div class="mr-auto w-44 flex-none space-y-8 sm:mr-0 sm:pt-52 lg:pt-36">
                        {#if imageUrls[1]}
                            <div class="relative">
                                <img src={getCdnUrl(imageUrls[1])}
                                     alt="" class="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg">
                                <div class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"></div>
                            </div>
                        {/if}
                        {#if imageUrls[2]}
                            <div class="relative">
                                <img src={getCdnUrl(imageUrls[2])}
                                     alt="" class="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg">
                                <div class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"></div>
                            </div>
                        {/if}
                    </div>
                    <div class="w-44 flex-none space-y-8 pt-32 sm:pt-0">
                        {#if imageUrls[3]}
                            <div class="relative">
                                <img src={getCdnUrl(imageUrls[3])}
                                     alt="" class="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg">
                                <div class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"></div>
                            </div>
                        {/if}
                        {#if imageUrls[4]}
                            <div class="relative">
                                <img src={getCdnUrl(imageUrls[4])}
                                     alt="" class="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg">
                                <div class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10"></div>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
